import type { Journey } from '@epilot/journey-logic-commons'
import { useEffect } from 'react'

export const useCustomCSS = (journey: Journey, customCss?: string) => {
  const id = journey.journeyId || journey.name

  // Add custom css to the head
  /**
   * @todo Refactor this to use the useInjectCss hook
   */
  useEffect(() => {
    if (!customCss || !id) {
      return
    }

    const styleId = `custom-css-${id}`
    let styleTag = document.getElementById(styleId)

    if (!styleTag) {
      styleTag = document.createElement('style')
      styleTag.id = styleId
      styleTag.innerHTML = customCss

      document.head.appendChild(styleTag)
    } else {
      styleTag.innerHTML = customCss
    }

    // If new nodes are added to the head, re-append the style tag
    const observer = new MutationObserver(() => {
      if (document.head.lastChild !== styleTag) {
        const customCSSTag = document.head.querySelector(`style#${styleId}`)

        if (customCSSTag) {
          document.head.removeChild(customCSSTag)
        }
        document.head.appendChild(styleTag)
      }
    })

    // Observe the last child
    observer.observe(document.head, { childList: true })

    return () => {
      if (styleTag) {
        styleTag.remove()
      }
      if (observer) {
        observer.disconnect()
      }
    }
  }, [customCss, id])
}
